import {
  CommentsList,
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
} from '../../components';
import Awards from '../templates/awards';
import styles from './logistic-expertise.module.css';

const awards = {
  title: 'awards',
  leadText:
    'Leading review & rating piatforms name us the top mobile app development company',
  leadImage: '/ios/rate.png',
  list: [
    {
      image: '/awards/item-1.jpg',
      text: 'Top Web Developers in Spain',
      title: 'Clutch',
    },
    {
      image: '/awards/item-2.jpg',
      text: 'Top Web Design in Spain',
      title: 'Clutch',
    },
    {
      image: '/awards/item-3.jpg',
      text: 'Top Swift App Development in Spain',
      title: 'Clutch',
    },
    {
      image: '/awards/item-4.jpg',
      text: 'Top Web Developers in Ukraine',
      title: 'Goodfirm',
    },
    {
      image: '/awards/item-5.jpg',
      text: 'Upwork TOP RATED 2022',
      title: 'Upwork',
    },
    {
      image: '/awards/item-6.jpg',
      text: 'Top Web Developers Companies 2020',
      title: 'Appfutura',
    },
  ],
};

export default function LogisticExpertise() {
  return (
    <>
      <section className={styles.root}>
        <Container>
          <Htag
            variant={HtagVariant.h2}
            align={HtagAlign.center}
            className={styles.title}
            tag="h2"
          >
            LOGISTICS DOMAIN EXPERTISE
          </Htag>
          <p className={styles.description}>
            We suggest vast experience in many technical instruments that can
            suit your logistics software well and solve many transportation
            tasks effectively.
          </p>
          <ul className={styles.list}>
            <li className={styles.item}>
              <div className={styles.card}>
                <h6 className={styles.card_text}>Routes Planning & Mapping</h6>
              </div>
            </li>
            <li className={styles.item}>
              <div className={styles.card}>
                <h6 className={styles.card_text}>Warehousing Management</h6>
              </div>
            </li>
            <li className={styles.item}>
              <div className={styles.card}>
                <h6 className={styles.card_text}>Traffic Management</h6>
              </div>
            </li>
            <li className={styles.item}>
              <div className={styles.card}>
                <h6 className={styles.card_text}>Fleet Management Solutions</h6>
              </div>
            </li>
            <li className={styles.item}>
              <div className={styles.card}>
                <h6 className={styles.card_text}>Order Management Systems</h6>
              </div>
            </li>
            <li className={styles.item}>
              <div className={styles.card}>
                <h6 className={styles.card_text}>Supply Chains Management</h6>
              </div>
            </li>
          </ul>
        </Container>
      </section>
      <Awards {...awards} />
      <section>
        <Container>
          <Htag
            variant={HtagVariant.h2}
            align={HtagAlign.center}
            className={styles.title}
            tag="h2"
          >
            Reviews from our clients
          </Htag>
          <CommentsList className={styles.comments} />
        </Container>
      </section>
    </>
  );
}
